module.exports = __webpack_public_path__ + "static/media/bridge-illustration.7ad6ffbf.svg";